import { render, staticRenderFns } from "./OrganigramaComp.vue?vue&type=template&id=148dd5a1&scoped=true&"
import script from "./OrganigramaComp.vue?vue&type=script&lang=js&"
export * from "./OrganigramaComp.vue?vue&type=script&lang=js&"
import style0 from "./OrganigramaComp.vue?vue&type=style&index=0&id=148dd5a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148dd5a1",
  null
  
)

export default component.exports